// Entry point for the ADMIN bundle (see admin.html + vite.config.ts's
// BUILD_TARGET switch). Mirrors main.tsx but mounts AdminApp, so the admin
// console ships as its own artifact/container with no customer-portal routes
// and, conversely, no admin code in the customer bundle.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import AdminApp from './AdminApp';
import i18n, { initI18n } from './i18n';
import { applyTheme, getStoredTheme } from './lib/theme';
import './styles/global.css';

initI18n();
applyTheme(getStoredTheme());
document.documentElement.lang = i18n.resolvedLanguage ?? 'de';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <AdminApp />
      </BrowserRouter>
    </I18nextProvider>
  </StrictMode>,
);
